// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'
import videojs from 'video.js';
import 'videojs-youtube';
import AOS from 'aos';

import Swiper, {Navigation, Pagination, Autoplay, EffectFade, EffectCoverflow} from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, EffectCoverflow]);

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

var printOptions = {
  margin: [0, -2, 0, 0],
  image: { type: 'jpeg', quality: 1 },
  html2canvas: {
    dpi: 192,
    scale:2,
    letterRendering: true,
    useCORS: true,
    scrollX: 0, scrollY: 0
  },
  filename: 'recipe.pdf',
  jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' }
}

if ($(".print-to-pdf").length) {
  $(".print-to-pdf").on('click', function(){
    window.scrollTo(0,0)
    $(".print-hidden").addClass('printing')
    var filename = $("#recipe_filename").data('title')
    if (filename) printOptions.filename = filename
    let footer = false
    html2canvas(document.getElementById('footerContent'), printOptions.html2canvas).then(function(canvas) {
      footer = canvas
      var element = document.getElementById('printable');
      html2pdf().set(printOptions).from(element).toPdf().get('pdf').then((pdf) => {
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          if (i == totalPages) {
            pdf.setPage(i);
            let height = pdf.internal.pageSize.getWidth() / footer.width * footer.height
            pdf.addImage(footer, 'png', 0, pdf.internal.pageSize.getHeight()-height, pdf.internal.pageSize.getWidth(), height)
          }
        }
      }).save().then(()=>{
        $(".print-hidden").removeClass('printing')
      })
    })
  })
}

var printButton = $('.print-to-pdf');
printButton.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

const nav = document.querySelector('.navbar');
window.addEventListener('scroll', () => {
  const scrollPos = window.scrollY;
  if (scrollPos > 20) {
    nav.classList.add('scrolled')
  } else {
    nav.classList.remove('scrolled')
  }
});


if ($('.recipe-page-hero__slider .swiper-container').length) {
  var recipeSwiper = new Swiper ('.swiper-container', {  
    fadeEffect: { 
      crossFade: true 
    },
    virtualTranslate: true,
    loop: true,
    speed: 250, 
    slidersPerView: 1,
    effect: "fade",
    navigation:{
      nextEl: '.recipe-page-hero__slider .swiper-button-next',
      prevEl: '.recipe-page-hero__slider .swiper-button-prev',
    }
  });
}

(function ($) {
  "use strict";
  // DOM Load

  if ($('.multi-select').length) {
    $('.multi-select').each(function() {
      $(this).find('.multi-select__items').slideUp(0);
    });

    $('.multi-select').on('mouseleave', function() {
      if ($(window).width() > 767) {
        var items = $(this).find('.multi-select__items');
        var itemsTitle = $(this).find('.multi-select__title');

        if (items.length && itemsTitle.length) {
          if (itemsTitle.hasClass('open')) {
            itemsTitle.removeClass('open');
          }
          items.slideUp(250);
        }
      }
    });

    $('.multi-select__title').on('click', function(ev) {
      ev.preventDefault();

      var items = $(this).parents('.multi-select').find('.multi-select__items');
      var itemsTitle = $(this).parents('.multi-select').find('.multi-select__title');
      
      if (items.length && itemsTitle.length) {
        if (itemsTitle.hasClass('open')) {
          items.slideUp(250);
          itemsTitle.removeClass('open');
        } else {
          items.slideDown(250);
          itemsTitle.addClass('open');
        }
      }
    });
  }

  if ($('.recipes-filters').length) {
    $('.recipes-filters').addClass('mobile-hide');
    $('.recipes-filters').slideUp(0);
    $('.recipes-filters__mobile-show-filters').show();
    $('.recipes-filters__mobile-hide-filters').hide();

    $('.recipes-filters__mobile-show-filters, .recipes-filters__mobile-hide-filters').on('click', function(ev) {
      ev.preventDefault();

      if ($('.recipes-filters').hasClass('mobile-hide')) {
        $('.recipes-filters').slideDown(250);
        $('.recipes-filters').removeClass('mobile-hide');
        $('.recipes-filters__mobile-show-filters').hide();
        $('.recipes-filters__mobile-hide-filters').show();
      } else {
        $('.recipes-filters').slideUp(250);
        $('.recipes-filters').addClass('mobile-hide');
        $('.recipes-filters__mobile-show-filters').show();
        $('.recipes-filters__mobile-hide-filters').hide();
      }
    });

    $('.recipes-filters').on('submit', function(ev) {
      ev.preventDefault();
  
      applyRecipesFilters();
    });
  
    function applyRecipesFilters() {
      if ($('.recipes-filters').length) {
        const params = {
          search: $('[name="search"]').val() || '',
          types: $.map($('[name="types"]:checked'), (val) => $(val).val()).join(',') || [],
          hurdles: $.map($('[name="hurdles"]:checked'), (val) => $(val).val()).join(',') || [],
          ingredients: $.map($('[name="ingredients"]:checked'), (val) => $(val).val()).join(',') || []
        };
  
        let url = $('.recipes-filters').attr('action') + '?';
  
        if (params.search.length) {
          url += (url.substr(-1,1) === '?' ? '' : '&') + `search=${params.search}`;
        }
        if (params.types.length) {
          url += (url.substr(-1,1) === '?' ? '' : '&') + `types=${params.types}`;
        }
        if (params.hurdles.length) {
          url += (url.substr(-1,1) === '?' ? '' : '&') + `hurdles=${params.hurdles}`;
        }
        if (params.ingredients.length) {
          url += (url.substr(-1,1) === '?' ? '' : '&') + `ingredients=${params.ingredients}`;
        }
  
        window.location = url;
      } else {
        console.warn('No recipes filters form.');
      }
    }
  }

  /*
    Module: Client Stories
  */

  // Initiate variables
  let clientStoriesVideos = [];
  let clientStoriesSwipers = [];

  // Initiate videos
  $('.client-story__video-js').each(function() {
    const lastIndex = clientStoriesVideos.length;
    $(this).attr('id', `client-stories-video--${lastIndex}`);
    clientStoriesVideos[lastIndex] = videojs($(this).attr('id'));

    // Add class swiper-no-swiping for poster element
    const playBtn = $(this).parents('.client-story').find('.client-story__video-js-poster__play-btn');
    if (playBtn.length && !playBtn.hasClass('swiper-no-swiping')) {
      playBtn.addClass('swiper-no-swiping');
    }

    // Show and hide poster if exists and video is playing
    clientStoriesVideos[lastIndex].on('play', function (player) {
      const poster = $(player.target).parents('.client-story').find('.client-story__video-js-poster');
      if (poster.length) {
        poster.hide(100);
      }
    });
    clientStoriesVideos[lastIndex].on('pause', function (player) {
      const poster = $(player.target).parents('.client-story').find('.client-story__video-js-poster');
      if (poster.length) {
        poster.show(100);
      }
    });
  });

  $('.client-story__video-js-poster__play-btn').on('click', function(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    const videoElement = $(this).parents('.client-story').find('.client-story__video-js');
    if (videoElement) {
      const videoIndex = videoElement.attr('id').replace('client-stories-video--', '');

      if (videoIndex || videoIndex === 0) {
        clientStoriesVideos[videoIndex].play();
      }
    }
  });

  // Initiate swipers
  $('.client-stories-swiper__container').each(function() {
    clientStoriesSwipers[clientStoriesSwipers.length] = new Swiper($(this)[0], {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: -30,
      breakpoints: {
        480: {
          spaceBetween: -60
        },
        768: {
          spaceBetween: -220
        },
        1080: {
          spaceBetween: -320
        },
        1200: {
          spaceBetween: -430
        },
        1400: {
          spaceBetween: -540
        },
        1600: {
          spaceBetween: -650
        },
        1800: {
          spaceBetween: -820
        },
        2000: {
          spaceBetween: -1020
        }
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 5,
        slideShadows: false,
      },
      pagination: {
        el: $(this).parents('.client-stories').find('.client-stories-swiper__pagination')[0],
      },
      on: {
        init: () => {
          $('.client-story .vjs-control-bar').addClass('swiper-no-swiping');
        },
        slideChangeTransitionEnd: () => {
          for(let i = 0; i < clientStoriesVideos.length; i++) {
            clientStoriesVideos[i].pause();
          }
        },
        slideChange: () => {
          for(let i = 0; i < clientStoriesVideos.length; i++) {
            clientStoriesVideos[i].pause();
          }
        }
      }
    })
  });

  $('p').each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
      $this.remove();
  });

  $('.header__navbar-toggler').on('click', function() {
    $('#header__navbar-collapse').toggle('collapse');
  });

  function showPopupGeneral() {
    if ($('.popup-general').length) {
      $('.popup-general').addClass('active');
    
    }
  }

  function hidePopupGeneral() {
    if ($('.popup-general').length) {
      $('.popup-general').removeClass('active');
    }
  }

  $('.popup-button').on('click', function(e) {
    e.preventDefault();
    showPopupGeneral();
  });
 

  $('.popup-general--close').on('click', function() {
    hidePopupGeneral();
  });

  var wpcf7Elm = document.querySelector( '.subscribe-form .wpcf7' );
  if (wpcf7Elm) {
    wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
      hidePopupGeneral();
      $('.subscribe-form .wpcf7').hide(200, () => {
        $('.subscribe-form .thankyou').show(200);
      })
    }, false );
  }


  function showPopupStory() {
    if ($('.popup-story').length) {
      $('.popup-story').addClass('active');
    }
  }

  function hidePopupStory() {
    if ($('.popup-story').length) {
      $('.popup-story').removeClass('active');
    }
  }

  $('.popup-story--close').on('click', function() {
    hidePopupStory();
  });

  $('.client-stories-case__button').on('click', function(e) {
    e.preventDefault();
    showPopupStory();
  });


  var wpcf7Story = document.querySelector( '.story-form .wpcf7' );
  if (wpcf7Story) {
    wpcf7Story.addEventListener( 'wpcf7submit', function( event ) {
      hidePopupStory();
      $('.story-form .wpcf7').hide(200, () => {
        $('.story-form .thankyou').show(200);
      })
    }, false );
  }

  AOS.init();
  
  $(document).ready(function () {
    // Web Loaded
  });

}(jQuery));



// WEBPACK FOOTER //
// ./resources/assets/js/app.js